import { DebugActionTypes, TOGGLE_META } from './actions';

interface IDebugReducerState {
  shouldShowMeta: boolean;
}

const initialState: IDebugReducerState = {
  shouldShowMeta: false,
};

export const debugReducer = (state = initialState, action: DebugActionTypes) => {
  switch (action.type) {
    case TOGGLE_META:
      return {
        ...state,
        shouldShowMeta: !state.shouldShowMeta,
      };
    default:
      return state;
  }
};
